enum PriceComparisonAlertRulePricePoint {
    MIN = "MIN",
    MAX = "MAX",
    MEDIAN = "MEDIAN",
}

export default PriceComparisonAlertRulePricePoint;